export const GOOGLE_API_KEY = 'AIzaSyBe2yxGHb1BOdXiDPqDb_O8xGwVfavVJD8'
export const AXEPTIO = process.env.MIX_AXEPTIO
export const GTM = process.env.MIX_GTM
